<ng-container *ngIf="machineAttributesInfo.length > 0 || hasLoadedAttributes">
    <app-show-grid-data
        [gridColumnDefs]="gridColumnDefs" 
        [gridData]="machineAttributesInfo" 
        [showKebabIcon]="true" 
        [gridConfigItems]="gridConfigItems"
        [loadMoreBinder]="loadMoreBinder"
        [searchText]="searchText"
        [parentComponentName]="'machineManagement'"
        (onGridCellClick)="onGridCellClick($event)"
        (onAddBtnClick)="onAddBtnClick($event)"
        (onSearch)="onSearch($event)"
    ></app-show-grid-data>
</ng-container>

